import { useToasts } from '../../../../cdl/Toast/useToasts';
import { translate } from '../../../../common/helpers/translate.helper';
import { useRole } from '../../../../common/hooks/useRole';
import { useSupplierSettingsEdit } from '../../../../company/supplier/detail/useSupplierSettingsEdit';
import { useSupplierCreate } from '../hooks/useSupplierCreate';

import { CreateSupplierCompanyForm, CreateSupplierCompanyFormProps } from './CreateSupplierCompanyForm';

interface CreateSupplierCompanyProps {
    groupId: string;
    onSuccess: () => void;
    isTestGroup: boolean;
}

export const CreateSupplierCompany = ({ groupId, onSuccess, isTestGroup }: CreateSupplierCompanyProps) => {
    const { addErrorToast } = useToasts();
    const role = useRole();

    const supplierCreateMutation = useSupplierCreate();
    const supplierSettingsMutation = useSupplierSettingsEdit();

    const handleSubmit: CreateSupplierCompanyFormProps['onSubmit'] = async (values) => {
        const supplierCompanyMessage = {
            supplierGroupId: groupId,
            name: values.name,
            email: values.email,
            phone: values.phone || undefined,
            fax: values.fax || undefined,
            address: {
                city: values.address.city || undefined,
                companyName: values.address.companyName || undefined,
                country: values.address.country || undefined,
                street: values.address.street || undefined,
                streetNumber: values.address.streetNumber || undefined,
                zipcode: values.address.zipcode || undefined,
            },
            testCompany: role.isSuperAdmin() ? values.testCompany : isTestGroup,
            showGtc: role.isSuperAdmin() ? values.showGtc : false,
            trial: role.isSuperAdmin() ? values.trial : false,
        };

        const supplierCompanySettingsMessage = {
            emailCategorySettings: {
                newChatMessage: false,
                offerStateChange: true,
                offerUpdate: true,
                systemReminder: true,
            },
            id: groupId,
            messageSettings: {
                oderConfirmationMessage: values.messageSettings.oderConfirmationMessage || undefined,
                quotationMessage: values.messageSettings.quotationMessage || undefined,
            },
        };
        try {
            const createdSupplier = await supplierCreateMutation.mutateAsync(supplierCompanyMessage);
            await supplierSettingsMutation.mutateAsync({
                id: createdSupplier.id,
                settings: supplierCompanySettingsMessage,
            });
            onSuccess();
        } catch {
            addErrorToast(translate('supplier.createErrorToast'));
        }
    };
    return <CreateSupplierCompanyForm onSubmit={handleSubmit} />;
};
